import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ParticipantPanel = ({ conversation }) => {
  const [activeTab, setActiveTab] = useState('info');

  const mockParticipants = [
  {
    id: 1,
    name: 'Rahul Sharma',
    role: 'Student',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11c45223e-1763291832973.png",
    avatarAlt: 'Professional headshot of young Indian man',
    isOnline: true
  },
  {
    id: 2,
    name: 'Priya Patel',
    role: 'Student',
    avatar: 'https://img.rocket.new/generatedImages/rocket_gen_img_1ee2bcef3-1763301295581.png',
    avatarAlt: 'Professional portrait of young woman',
    isOnline: false
  },
  {
    id: 3,
    name: 'Dr. Amit Kumar',
    role: 'Coordinator',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18316acce-1763293751803.png",
    avatarAlt: 'Professional photo of man in business attire',
    isOnline: true
  }];


  const mockSharedFiles = [
  {
    id: 1,
    name: 'Resume_Rahul_Sharma.pdf',
    size: '245 KB',
    type: 'pdf',
    sharedBy: 'Rahul Sharma',
    sharedAt: '2 days ago'
  },
  {
    id: 2,
    name: 'Interview_Schedule.xlsx',
    size: '128 KB',
    type: 'excel',
    sharedBy: 'You',
    sharedAt: '1 week ago'
  },
  {
    id: 3,
    name: 'Company_Presentation.pptx',
    size: '3.2 MB',
    type: 'powerpoint',
    sharedBy: 'Tech Innovations HR',
    sharedAt: '2 weeks ago'
  }];


  const getFileIcon = (type) => {
    switch (type) {
      case 'pdf':
        return 'FileText';
      case 'excel':
        return 'FileSpreadsheet';
      case 'powerpoint':
        return 'Presentation';
      case 'image':
        return 'Image';
      default:
        return 'File';
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-center mb-4">
          <img
            src={conversation?.avatar}
            alt={conversation?.avatarAlt}
            className="w-20 h-20 rounded-full object-cover" />

        </div>
        <h3 className="font-semibold text-center text-foreground mb-1">{conversation?.name}</h3>
        <p className="text-sm text-center text-muted-foreground mb-4">
          {conversation?.type === 'group' ? `${conversation?.participants} participants` : conversation?.role}
        </p>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" iconName="Phone" fullWidth>
            Call
          </Button>
          <Button variant="outline" size="sm" iconName="Video" fullWidth>
            Video
          </Button>
        </div>
      </div>
      <div className="border-b border-border">
        <div className="flex">
          <button
            onClick={() => setActiveTab('info')}
            className={`flex-1 px-4 py-3 text-sm font-medium transition-smooth ${
            activeTab === 'info' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
            }>

            Info
          </button>
          <button
            onClick={() => setActiveTab('files')}
            className={`flex-1 px-4 py-3 text-sm font-medium transition-smooth ${
            activeTab === 'files' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
            }>

            Files
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`flex-1 px-4 py-3 text-sm font-medium transition-smooth ${
            activeTab === 'settings' ? 'text-primary border-b-2 border-primary' : 'text-muted-foreground hover:text-foreground'}`
            }>

            Settings
          </button>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {activeTab === 'info' &&
        <div className="space-y-4">
            {conversation?.type === 'group' ?
          <>
                <div>
                  <h4 className="text-sm font-semibold text-foreground mb-3">Participants</h4>
                  <div className="space-y-2">
                    {mockParticipants?.map((participant) =>
                <div key={participant?.id} className="flex items-center gap-3 p-2 hover:bg-muted rounded-lg transition-smooth">
                        <div className="relative">
                          <img
                      src={participant?.avatar}
                      alt={participant?.avatarAlt}
                      className="w-10 h-10 rounded-full object-cover" />

                          {participant?.isOnline &&
                    <span className="absolute bottom-0 right-0 w-3 h-3 bg-success border-2 border-card rounded-full" />
                    }
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-foreground truncate">{participant?.name}</p>
                          <p className="text-xs text-muted-foreground">{participant?.role}</p>
                        </div>
                      </div>
                )}
                  </div>
                </div>
                <Button variant="outline" iconName="UserPlus" fullWidth>
                  Add Participant
                </Button>
              </> :

          <div className="space-y-3">
                <div className="flex items-center gap-3 text-sm">
                  <Icon name="Mail" size={16} className="text-muted-foreground" />
                  <span className="text-foreground">contact@example.com</span>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <Icon name="Phone" size={16} className="text-muted-foreground" />
                  <span className="text-foreground">+91 98765 43210</span>
                </div>
                <div className="flex items-center gap-3 text-sm">
                  <Icon name="MapPin" size={16} className="text-muted-foreground" />
                  <span className="text-foreground">Mumbai, Maharashtra</span>
                </div>
              </div>
          }
          </div>
        }

        {activeTab === 'files' &&
        <div className="space-y-2">
            {mockSharedFiles?.length === 0 ?
          <div className="text-center py-8">
                <Icon name="FileX" size={48} className="text-muted-foreground mx-auto mb-3" />
                <p className="text-sm text-muted-foreground">No shared files</p>
              </div> :

          mockSharedFiles?.map((file) =>
          <div
            key={file?.id}
            className="flex items-center gap-3 p-3 bg-muted rounded-lg hover:bg-muted/80 transition-smooth cursor-pointer">

                  <div className="w-10 h-10 bg-background rounded flex items-center justify-center">
                    <Icon name={getFileIcon(file?.type)} size={20} className="text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground truncate">{file?.name}</p>
                    <p className="text-xs text-muted-foreground">
                      {file?.size} • {file?.sharedBy} • {file?.sharedAt}
                    </p>
                  </div>
                  <Button variant="ghost" size="icon" iconName="Download" />
                </div>
          )
          }
          </div>
        }

        {activeTab === 'settings' &&
        <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-foreground">Notifications</p>
                <p className="text-xs text-muted-foreground">Receive message alerts</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" defaultChecked />
                <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
              </label>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-foreground">Mute Conversation</p>
                <p className="text-xs text-muted-foreground">Silence notifications</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" />
                <div className="w-11 h-6 bg-muted peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-ring rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
              </label>
            </div>
            <div className="pt-4 border-t border-border space-y-2">
              <Button variant="outline" iconName="Archive" fullWidth>
                Archive Conversation
              </Button>
              <Button variant="outline" iconName="Ban" fullWidth>
                Block User
              </Button>
              <Button variant="danger" iconName="Trash2" fullWidth>
                Delete Conversation
              </Button>
            </div>
          </div>
        }
      </div>
    </div>);

};

export default ParticipantPanel;